// MT home dashboard (zone layout) strings: mtdSnapshot. Keys use the "mtd-" prefix.
export default {
  en: {
    'mtd-snapshot-title': 'Snapshot',
    'mtd-snapshot-vs-same-day': 'vs. same day last year',
    'mtd-snapshot-vs-same-date': 'vs. same date last year',
    'mtd-snapshot-sales': 'Sales',
    'mtd-snapshot-service': 'Service',
    'mtd-snapshot-labor': 'Labor',
    'mtd-snapshot-cash': 'Cash',
    'mtd-snapshot-pmix': 'PMIX',
    'mtd-snapshot-dayparts': 'Dayparts',
    'mtd-snapshot-peaks': 'Peaks',
    'mtd-snapshot-no-data': 'No data for this period',
    'mtd-snapshot-no-peaks': 'No peak windows are set up yet',
    'mtd-snapshot-pmix-unconfigured':
      'No PMIX products configured. Ask your administrator to select menu items or watchlists in Role Defaults.',
    'mtd-snapshot-pmix-item': 'Item',
    'mtd-snapshot-pmix-sold': 'Sold',
    'mtd-snapshot-pmix-used': 'Used',
    'mtd-snapshot-pmix-promo': 'Promo',
    'mtd-snapshot-metric': 'Metric',
    'mtd-snapshot-time-range': 'Time range',
  },
  es: {
    'mtd-snapshot-title': 'Resumen',
    'mtd-snapshot-vs-same-day': 'vs. mismo día del año pasado',
    'mtd-snapshot-vs-same-date': 'vs. misma fecha del año pasado',
    'mtd-snapshot-sales': 'Ventas',
    'mtd-snapshot-service': 'Servicio',
    'mtd-snapshot-labor': 'Mano de obra',
    'mtd-snapshot-cash': 'Efectivo',
    'mtd-snapshot-pmix': 'PMIX',
    'mtd-snapshot-dayparts': 'Franjas del día',
    'mtd-snapshot-peaks': 'Picos',
    'mtd-snapshot-no-data': 'Sin datos para este período',
    'mtd-snapshot-no-peaks': 'Aún no hay periodos pico configurados',
    'mtd-snapshot-pmix-unconfigured':
      'No hay productos PMIX configurados. Pida a su administrador que seleccione artículos del menú o listas de seguimiento en Valores predeterminados de rol.',
    'mtd-snapshot-pmix-item': 'Artículo',
    'mtd-snapshot-pmix-sold': 'Vendidos',
    'mtd-snapshot-pmix-used': 'Usados',
    'mtd-snapshot-pmix-promo': 'Promo',
    'mtd-snapshot-metric': 'Métrica',
    'mtd-snapshot-time-range': 'Rango de tiempo',
  },
  fr: {
    'mtd-snapshot-title': 'Aperçu',
    'mtd-snapshot-vs-same-day': "vs. même jour l'an dernier",
    'mtd-snapshot-vs-same-date': "vs. même date l'an dernier",
    'mtd-snapshot-sales': 'Ventes',
    'mtd-snapshot-service': 'Service',
    'mtd-snapshot-labor': "Main-d'œuvre",
    'mtd-snapshot-cash': 'Caisse',
    'mtd-snapshot-pmix': 'PMIX',
    'mtd-snapshot-dayparts': 'Périodes de la journée',
    'mtd-snapshot-peaks': 'Pointes',
    'mtd-snapshot-no-data': 'Aucune donnée pour cette période',
    'mtd-snapshot-no-peaks': 'Aucune période de pointe n’est encore configurée',
    'mtd-snapshot-pmix-unconfigured':
      'Aucun produit PMIX configuré. Demandez à votre administrateur de sélectionner des articles du menu ou des listes de suivi dans les paramètres par défaut du rôle.',
    'mtd-snapshot-pmix-item': 'Article',
    'mtd-snapshot-pmix-sold': 'Vendus',
    'mtd-snapshot-pmix-used': 'Utilisés',
    'mtd-snapshot-pmix-promo': 'Promo',
    'mtd-snapshot-metric': 'Indicateur',
    'mtd-snapshot-time-range': 'Plage horaire',
  },
  'fr-ca': {
    'mtd-snapshot-title': 'Aperçu',
    'mtd-snapshot-vs-same-day': "vs. même jour l'an dernier",
    'mtd-snapshot-vs-same-date': "vs. même date l'an dernier",
    'mtd-snapshot-sales': 'Ventes',
    'mtd-snapshot-service': 'Service',
    'mtd-snapshot-labor': "Main-d'œuvre",
    'mtd-snapshot-cash': 'Caisse',
    'mtd-snapshot-pmix': 'PMIX',
    'mtd-snapshot-dayparts': 'Périodes de la journée',
    'mtd-snapshot-peaks': 'Pointes',
    'mtd-snapshot-no-data': 'Aucune donnée pour cette période',
    'mtd-snapshot-no-peaks': 'Aucune période de pointe n’est encore configurée',
    'mtd-snapshot-pmix-unconfigured':
      'Aucun produit PMIX configuré. Demandez à votre administrateur de sélectionner des articles du menu ou des listes de suivi dans les paramètres par défaut du rôle.',
    'mtd-snapshot-pmix-item': 'Article',
    'mtd-snapshot-pmix-sold': 'Vendus',
    'mtd-snapshot-pmix-used': 'Utilisés',
    'mtd-snapshot-pmix-promo': 'Promo',
    'mtd-snapshot-metric': 'Indicateur',
    'mtd-snapshot-time-range': 'Plage horaire',
  },
};
